type TrustpilotConfig = {
  businessUnitId: string
  href: string
  locale: string
}

export const TrustpilotConfiguration: Record<
  string,
  Record<string, TrustpilotConfig>
> = {
  'cottages.com': {
    'en-GB': {
      businessUnitId: '5924321f0000ff0005a306c7',
      href: 'https://uk.trustpilot.com/review/cottages.com',
      locale: 'en-GB',
    },
  },
  hoseasons: {
    'en-GB': {
      businessUnitId: '4aa6d5d7000064000504b89b',
      href: 'https://uk.trustpilot.com/review/www.hoseasons.co.uk',
      locale: 'en-GB',
    },
  },
  fincallorca: {
    'de-DE': {
      businessUnitId: '4d05f2d400006400050e41ad',
      href: 'https://de.trustpilot.com/review/fincallorca.de',
      locale: 'de-DE',
    },
  },
  novasol: {
    'de-DE': {
      businessUnitId: '4883122f000064000502fff5',
      href: 'https://de.trustpilot.com/review/www.novasol.de',
      locale: 'de-DE',
    },
    da: {
      businessUnitId: '46a1621100006400050050fb',
      href: 'https://dk.trustpilot.com/review/www.novasol.dk',
      locale: 'da-DK',
    },
    fr: {
      businessUnitId: '4e69df5a000064000510f372',
      href: 'https://fr.trustpilot.com/review/www.novasol-vacances.fr',
      locale: 'fr-FR',
    },
    it: {
      businessUnitId: '4e69df33000064000510f370',
      href: 'https://it.trustpilot.com/review/www.novasol.it',
      locale: 'it-IT',
    },
    sv: {
      businessUnitId: '4be69b2f0000640005097b62',
      href: 'https://se.trustpilot.com/review/www.novasol.se',
      locale: 'sv-SE',
    },
    pl: {
      businessUnitId: '59a526f50000ff0005a9ea4e',
      href: 'https://pl.trustpilot.com/review/www.novasol.pl',
      locale: 'pl-PL',
    },
    nb: {
      businessUnitId: '4c97ed5000006400050de3f1',
      href: 'https://no.trustpilot.com/review/novasol.no',
      locale: 'nb-NO',
    },
    'nl-NL': {
      businessUnitId: '4e54cccb000064000510d887',
      href: 'https://nl.trustpilot.com/review/novasol.nl',
      locale: 'nl-NL',
    },
    'en-GB': {
      businessUnitId: '46a1637800006400050059cd',
      href: 'https://uk.trustpilot.com/review/www.novasol.co.uk',
      locale: 'en-GB',
    },
  },
}
